"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtpFormToJSON = exports.OtpFormFromJSONTyped = exports.OtpFormFromJSON = void 0;
const runtime_1 = require("../runtime");
function OtpFormFromJSON(json) {
    return OtpFormFromJSONTyped(json, false);
}
exports.OtpFormFromJSON = OtpFormFromJSON;
function OtpFormFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'phoneNumber': !runtime_1.exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'emailAddress': !runtime_1.exists(json, 'emailAddress') ? undefined : json['emailAddress'],
    };
}
exports.OtpFormFromJSONTyped = OtpFormFromJSONTyped;
function OtpFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'phoneNumber': value.phoneNumber,
        'emailAddress': value.emailAddress,
    };
}
exports.OtpFormToJSON = OtpFormToJSON;
//# sourceMappingURL=OtpForm.js.map